module.exports = __webpack_public_path__ + "static/testaboutbg-2d97c020259f280c4f1622657f4d1be1.jpg";